import { useTranslation } from "@opendash/i18n";

/**
 * Use this prefix to translate meta fields.
 */
const PREFIX = "sourcemeta.view.meta.label.";

/**
 * Returns a function that translates the given field, if no translation is found the field is returned instead of the translation key.
 * @returns A function that translates the given field
 */
export const useMetaTranslate = () => {
  const t = useTranslation();

  /**
   * Translates the given field, if no translation is found the field is returned instead of the translation key.
   * @param field just the fieldname without the prefix
   * @param contextOrDefault object containing attributes that can be used in the translation
   * @returns translated field or field if no translation is found
   */
  function mt(field: string, contextOrDefault?: any) {
    let noTranslation =
      t("maintenance:" + PREFIX + field) === PREFIX + field ||
      t("maintenance:" + PREFIX + field) === "maintenance:" + PREFIX + field;

    return noTranslation
      ? field
      : t("maintenance:" + PREFIX + field, contextOrDefault);
  }

  return mt;
};
